import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Color from '@/utils/color';
import Icon from '../../../../components/Icon';
import { Header, ButtonSmall } from '../../../../components/Text';
import { FLEX_CENTER_CENTER } from '@/utils/styles';

const IMAGE_SIZE = '90px';

export const ProductItemContainer = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${Color.CoolGrey};
`;

export const ProductItem = styled.div`
  display: flex;
  height: ${IMAGE_SIZE};
  position: relative;
`;

export const ProductImageContainer = styled.div`
  width: ${IMAGE_SIZE};
  height: ${IMAGE_SIZE};
  min-width: ${IMAGE_SIZE};
  max-width: ${IMAGE_SIZE};
  min-height: ${IMAGE_SIZE};
  max-height: ${IMAGE_SIZE};
  ${FLEX_CENTER_CENTER};
  position: relative;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProductInfoContainer = styled.div`
  display: flex;
  padding-left: 1rem;
  flex: 1;
  overflow: hidden;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 5px;
    background: rgba(255, 255, 255, 0.9);
    opacity: 0.7;
  }
`;

export const ProductInfo = styled.div`
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
`;

export const IconButton = styled(Icon)`
  padding: 0 0.5rem;
  cursor: pointer;
`;

const IconButtonLink = styled.a`
  display: flex;
  align-items: center;
`;

export const LabeledIconButton = ({
  name,
  color,
  children,
  onClick,
  loading,
}) => (
  <IconButtonLink onClick={!loading ? onClick : null}>
    <IconButton name={name} color={color} />
    {loading && <span>Loading...</span>}
    {!loading && children}
  </IconButtonLink>
);
LabeledIconButton.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  children: PropTypes.any,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};
LabeledIconButton.defaultProps = {
  color: null,
  children: null,
  loading: false,
  onClick: null,
};

export const ProductName = styled(Header)`
  font-size: 0.9rem;
  padding-bottom: 0.5rem;
  cursor: pointer;
`;

export const ProductDescription = styled(ButtonSmall)``;

export const ProductPrice = styled.div`
  font-size: 0.8rem;
  white-space: pre;
  color: ${({ theme, discounted }) =>
    discounted ? theme.color.accent : theme.color.primary};
`;
